import { inject, Injectable, signal } from '@angular/core';
import { ETenantProfile, Tenant } from '@insolution/graphql-data-access';
import { SessionStorageService } from '@insolution/store-data-access';

@Injectable({
  providedIn: 'root',
})
export class CurrentTenantService {
  public currentTenant = signal<Tenant | null>(null);
  public currentTenantId = signal<string | null>(null);
  public currentTenantRef = signal<string | null>(null);
  public currentTenantName = signal<string | null>(null);
  public currentTenantProfile = signal<ETenantProfile | null>(null);
  public currentTenantDoesOwnModelling = signal<boolean>(false);
  public currentWorkshopMillingTenantRef = signal<string | null>(null);
  public currentWorkshopMillingTenantId = signal<string | null>(null);
  public currentWorkshopMillingTenantName = signal<string | null>(null);
  public currentWorkshopPrintingTenantRef = signal<string | null>(null);
  public currentWorkshopPrintingTenantId = signal<string | null>(null);
  public currentWorkshopPrintingTenantName = signal<string | null>(null);

  private sessionStorageService = inject(SessionStorageService);

  constructor() {
    const tenantToSet = this.sessionStorageService.getItem<Tenant>('currentTenant') || null;

    this.setCurrentTenantProperties(tenantToSet);
  }

  public setCurrentTenant(tenant: Tenant): void {
    this.sessionStorageService.storeItem<Tenant>('currentTenant', tenant);

    this.setCurrentTenantProperties(tenant);
  }

  public clearCurrentTenant(): void {
    this.sessionStorageService.removeItem('currentTenant');

    this.setCurrentTenantProperties(null);
  }

  private setCurrentTenantProperties(tenant: Tenant | null): void {
    this.currentTenant.set(tenant);
    this.currentTenantId.set(tenant?.id || null);
    this.currentTenantRef.set(tenant?.tenant_ref || null);
    this.currentTenantName.set(tenant?.name || null);
    this.currentTenantProfile.set(tenant?.profile || null);
    this.currentTenantDoesOwnModelling.set(tenant?.does_own_modelling ?? false);
    this.currentWorkshopMillingTenantRef.set(tenant?.workshop_milling_tenant_ref || null);
    this.currentWorkshopMillingTenantId.set(tenant?.workshop_milling_tenant_id || null);
    this.currentWorkshopMillingTenantName.set(tenant?.workshop_milling_tenant_name || null);
    this.currentWorkshopPrintingTenantRef.set(tenant?.workshop_printing_tenant_ref || null);
    this.currentWorkshopPrintingTenantId.set(tenant?.workshop_printing_tenant_id || null);
    this.currentWorkshopPrintingTenantName.set(tenant?.workshop_printing_tenant_name || null);
  }
}
